import { setIntersectionObserver } from "../helpers";

/**
 * @file Default transition that handle DOM animations.
 */
export default class Animation {

	/**
	 * @arg {object} view — Animation view
	 * @constructor
	 */

	// TODO: Configure options
	constructor(element, options = {}) {
		this.element = element;

		if (this.element.className.indexOf("bound") > -1) return;

		this.element.resetOnExit = false;
		this.element.classList.add("bound");
		this.type = (this.element.dataset.animation) ? this.element.dataset.animation : "default";
		this.trigger = (this.element.dataset.trigger) ? this.element.dataset.trigger : "observe";

		/** --- Setup observer --- */
		window.Zero.observer = window.Zero.observer || setIntersectionObserver();

		/** --- Grab events objects --- */
		window.Zero.events = window.Zero.events || {};
		window.Zero.events.observed = window.Zero.events.observed || [];

		this.bindings(this.element);

		if(this.setDefault) this.setDefault();
	}

	bindings() {

		/**
		 * Data values
		 */
		if(this.onViewportEnter || this.onViewportExit) {

			window.Zero.events.observed.push(this.element);
			window.Zero.observer.observe(this.element);
		}

		if(this.onViewportEnter) this.element.addEventListener("viewportEnter", this.onViewportEnter.bind(this));
		if(this.onViewportExit) this.element.addEventListener("viewportExit", this.onViewportExit.bind(this));
	}

	run(callback = null) {

		this.promise = new Promise(resolve => {
			this.animate && this.animate({ done: resolve });
		});

		if (callback) this.promise.then(callback);
	}
}
